import { productAddToCartButtonStyles } from "@insite/content-library/Components/ProductAddToCartButton";
import { ButtonIcon } from "@insite/mobius/Button/Button";
import ShopCart from "@store/Components/Icons/ShopCart";
import { css } from "styled-components";

Object.assign(productAddToCartButtonStyles, {
    variant: "primary",
    css: css`
        ${({ theme }) => theme?.button?.primary?.css}
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 0;

        ${ButtonIcon} {
            top: auto;
            width: 1.5em;
            height: 1.5em;

            svg {
                width: 100%;
                height: auto;
            }
        }
    `,
    icon: {
        src: ShopCart,
        position: "left",
    },
});
